// extracted by mini-css-extract-plugin
export default {"chip":"TagChip_chip__G1WUW","chip--sm":"TagChip_chip--sm__QRDbK","chip--md":"TagChip_chip--md__hw8aZ","label":"TagChip_label__pY2Ax","remove":"TagChip_remove__9MFvB"};